import React from 'react';
import { View } from 'react-native';
import { styleSheet, colors, sizes, HEIGHT,} from 'app/utils/styleSheet'

export default class CustomSlider extends React.Component {
  // style={[styles.row]}
  // // onSlidingComplete={val => alert(val)}
  // value={scale}
  // // onValueChange={val => onUpdateScale(val)}
  // onSlidingComplete={val => onUpdateScale(val)}
  // minimumValue={0.1}
  // maximumValue={1.0}
  // minimumTrackTintColor={colors.active}

  render() {
    let { value, step, minimumValue, maximumValue, onSlidingComplete, style, } = this.props
    return (
      <View style={style}>
        <input 
          type="range" 
          value={value}
          min={minimumValue}
          max={maximumValue}
          onChange={event => {
            let val = event.target.value
            onSlidingComplete(parseInt(val))
          }}
          step={step || 1}
        />
      </View>
    )
  }
}